class CartProducts extends HTMLElement {
  constructor() {
    super();
    this.productIds = this.getAttribute('data-product-ids').split(',');
    this.limit = parseInt(this.getAttribute('data-limit'), 10);
    this.swiperElem = this.querySelector('.swiper');
    this.swiperWrapperElem = this.swiperElem.querySelector('.swiper-wrapper');
    this.products = new Array();

  }
  connectedCallback() {
    this._processProductIds();
  }
    _processProductIds() {
    const self = this;
    self.productIds.forEach(productId => {
      fetch(`${window.Shopify.routes.root}recommendations/products?product_id=${productId}&limit=${self.limit}&section_id=cart-recommended-products`)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        const products = new Array(...doc.querySelectorAll('.cart-promoted-product'));
        const newProducts = products.filter(product => !self.productIds.includes(product.getAttribute('data-id')));
        self.products.push(newProducts);
        if(self.products.length === self.productIds.length) {
          self._initializeSwiperSlides();
        }
      })
      .catch(error => {
        console.error('Error fetching recommended products:', error);
      });
    });
  }
  _initializeSwiperSlides() {
    this.products = this.products.flat();
    this.products = this.products.reduce((acc, current) => {
      const x = acc.find((item) => item.getAttribute('data-id') === current.getAttribute('data-id'));
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    for (const product of this.products) {
      let template = null;
      try {
        template = document.getElementById('cart-promoted-product').content.firstElementChild.cloneNode(true);
        template.appendChild(product);
      } catch (error) {
        console.error('Error creating template:', error);
      }
      if (template) {
        this.swiperWrapperElem.appendChild(template);
      }
    }
    this._initSwiper();
  }
  createPriceHtml(product) {
    const compareAtPrice = product.compare_at_price;
    const price = product.price;
    if (compareAtPrice && compareAtPrice > price) {
      const template = document.getElementById('cart-promoted-product-price-compare-at').content.firstElementChild.cloneNode(true);
      template.querySelector(".price-item__compare .price-item s").textContent = formatMoney(compareAtPrice, this.getAttribute('data-money-format'));
      template.querySelector(".price__sale .price-item").textContent = formatMoney(price, this.getAttribute('data-money-format'));
      return template.innerHTML;
    } else {
      const template = document.getElementById('cart-promoted-product-price').content.firstElementChild.cloneNode(true);
      template.querySelector(".price__sale .price-item").textContent = formatMoney(price, this.getAttribute('data-money-format'));
      return template.innerHTML;
    }
  }
  _initSwiper() {
    this.swiper = new Swiper(this.swiperElem, {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 10,
      initialSlide: 1,
      pagination: {
        el: this.swiperElem.querySelector('.cart-promoted-products-swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: this.swiperElem.querySelector('.cart-promoted-products-swiper-button--next'),
        prevEl: this.swiperElem.querySelector('.cart-promoted-products-swiper-button--prev'),
      },
      on: {
        init: () => {
          this.classList.add('active');
        },
      }
    });
  }
  disconnectedCallback() {
  }
}
customElements.define('cart-products', CartProducts);